<!--商品详情-->
<template>
  <div class="detail">
    <div class="detail_container">
      <!-- 上侧面包屑 -->
      <div class="breadcrumb1">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/models' }">模型库</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ modelName }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="translate" @click="shareUrl">
          <img src="../../assets/image/资源 233.png" title="分享">
        </div>
      </div>
      <!-- 模型整行 -->
      <div class="gray-box">
        <div class="gallery-wrapper">
          <div class="gallery">
              <div class="big">
                  <!-- <el-container v-loading="true" element-loading-text="模型加载中" element-loading-background="rgba(0, 0, 0, 0.8)">
                  </el-container> -->
                  <!-- <div class="loadingModal" v-if="isLoading">
                    <el-progress
                        :style="{width:'40%',margin:'0 auto'}"
                        :width="70"
                        :percentage="percentage"
                        :show-text="false"
                        :status="percentage === 100?undefined:'success'"
                    ></el-progress>
                  </div> -->
                  <el-container style="height: 100%;" v-loading="isLoading" element-loading-text="模型加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="model_container" ref="container"></div>
                  </el-container>
              </div>
          </div>
        </div>
        <!--右边-->
        <div class="banner">
          <div class="sku-custom-title">
            <img :src="modelThumbnail" />
          </div>
          <div class="num">
            <span class="model_name">{{ modelName }}</span>
            <div class="label">
              <span class="tags" v-for="(item, index) in modelTag" :key="index">{{ item }}</span>
            </div>
            <ul>
              <li v-for="(item, index) in modelInformation" :key="index">
                <span class="name">{{ item.name }}:</span>
                <span class="value">{{ item.value }}</span>
              </li>
            </ul>
            <!-- <div class="company">
              <span>所属公司：</span>
              <span style="color: #DDDDDD;">{{ company }}</span>
              <p style="margin-top: 1rem">公司介绍：{{ description }}</p>
            </div> -->
            <div class="collect">
              <el-button v-if="!isCollection" @click="addMyCollection(id)">加入收藏</el-button>
              <el-button v-if="isCollection" @click="cancelCollection(id)">取消收藏</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 用户头像 -->
      <div class="information-box">
        <div class="information-wrapper">
          <div class="user">
            <img :src="modelCreatorAvatar" style="width: 2.5rem; border-radius: 90%;">
            <span class="username">{{ modelCreator }}</span>
            <span class="time">{{ modelCreateTime }}</span>
          </div>
          <div class="introduce">
            <p>模型介绍：</p>
            <span>{{ modelNote }}</span>
          </div>
        </div>
        <div class="buy">
            
          </div>
      </div>
      <!-- 下侧面包屑 -->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/models' }"
            >模型库</el-breadcrumb-item>
          <el-breadcrumb-item>更多</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--相关推荐-->
      <div class="item-info">
        <div v-for="(item) in industrialModel" :key="item.id" style="cursor:pointer;" class="item">
          <ModelShowFrame :name="item.name" :model="item.thumbnail"
                          :user="item.nickname" :userIcon="item.avatar"
                          :id="item.id" :isModelCollection="item.isCollected"></ModelShowFrame>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModelShowFrame from "../../components/modelShowFrame/index";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GUI } from "three/examples/jsm/libs/lil-gui.module.min.js";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { DDSLoader } from "three/examples/jsm/loaders/DDSLoader";
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { aesDecrypt } from './index'
import { TextureLoader } from "three";
import { getModelById, sharePrivateModel, changeCollectState, getAllModel, collectModel, cancelUserCollectUserModel } from '../../util/index'

import ColorGUIHelper  from './gui'

const loadOnlineModel = async(that, scene, model, color, metal, normal, ao ) => {

    // const that = that

    const loader = new FBXLoader();
    // const imgLoader = new DDSLoader();
    const imgLoader = new TextureLoader()
    // let modelOnLine = 'https://pgov.oss-cn-qingdao.aliyuncs.com/240103/ff04b65f974f4ded8651059bf8111338.fbx'
    let modelUrl = await aesDecrypt(model)

    // 贴图
    // let colorMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/240103/619c305752c64171bcca38010c344909.dds'
    // let colorMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/231018/95a29a1fa5bf4bbd9dfaedb166367e29.png'

    // 颜色贴图
    let textureCL = null
    let textureN = null
    let textureAo = null
    let textureMetallic = null
    if(!color){
        textureCL = null
    }else{
        let colorMap = await aesDecrypt(color)
        textureCL = imgLoader.load(colorMap)
        textureCL.colorSpace = THREE.SRGBColorSpace;
    }
    // let normalMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/240103/1e1a565137ee497b89396d27a850681e.dds'
    // let normalMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/231018/775f0645b55349b2b785c25e963c0321.png'

    // 法线贴图
    if(!normal){
        textureN = null
    }else{
        let normalMap = await aesDecrypt(normal)
        textureN = imgLoader.load(normalMap)
    }
    // let roughMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/240103/92a4f223f1234237b0fcd32f9dae4243.dds'
    // rough = await aesDecrypt(roughMap)
    // let textureJS = imgLoader.load(rough)

    // ao贴图
    // let aoMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/231018/926b4cf8b25b41178219063180b0058f.png'
    // ao = await aesDecrypt(aoMap)
    if(!ao){
        textureAo = null
    }else{
        let aoMap = await aesDecrypt(ao)
        textureAo = imgLoader.load(aoMap)
    }

    // 金属度贴图
    // let metallicMap = 'https://pgov.oss-cn-qingdao.aliyuncs.com/231018/6840c476d0764a8c810f451587e54b06.png'
    if(!metal){
      textureMetallic = null
    }else{
      let metallic = await aesDecrypt(metal)
      textureMetallic = imgLoader.load(metallic)
    }

    // 材质
    let material = new THREE.MeshStandardMaterial({
      aoMap: textureAo,
      normalMap: textureN,
      metalnessMap: textureMetallic,
      map: textureCL,
      metalness: 1,
      // roughnessMap : ,
      roughness: 0.5
    })

    loader.load(modelUrl, (fbx) => {
      traverseModel(fbx, material)
      // var box = new THREE.Box3()
      // box.expandByObject(fbx)
      // var center = new THREE.Vector3()
      // box.getCenter(center)
      // var distance = Math.max(box.max.x - box.min.x, Math.max(box.max.y - box.min.y, box.max.z - box.min.z));
      // var direction = new THREE.Vector3()
      // that.camera.getWorldDirection(direction)
      // direction.negate()
      // center.add(direction.multiplyScalar(distance * 2))
      // that.camera.position.set(center.x, center.y, center.z)
      const box = new THREE.Box3().setFromObject(fbx)
      const x = box.max.x - box.min.x
      const y = box.max.y - box.min.y
      const z = box.max.z - box.min.z
      const maxDim = Math.max(x, y, z)
      const scale = 2.5 / maxDim
      scene.scale.set(scale, scale, scale)
      fbx.position.set(0, 0, 0)
      scene.add(fbx)
    }, (xhr) => {
      that.percentage = parseInt(xhr.loaded / xhr.total * 100)
      console.log((xhr.loaded / xhr.total * 100) + '% loaded')
      if((xhr.loaded / xhr.total  *100 )===100){
        that.isLoading = false
      }
    })

    function traverseModel(element, material){
      if(element.isMesh){
        element.material = material
      }
      element.castShadow = true
      element.receiveShadow = true
      element.children.forEach(child => {
        traverseModel(child, material);
      });
    }

}
export default {
  data() {
    return {
      id: '',
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      controls: null,
      meshCar: null,
      modelName: "",  // 模型名字
      modelNote: "",  // 模型介绍
      modelThumbnail: "",  // 模型缩略图
      modelTag: "",  // 模型标签
      modelSize: "",  // 模型大小
      modelFormat: "",  // 模型格式
      modelDimension: "",  // 模型尺寸
      modelCreateTime: "",  // 模型创建时间
      modelCreator: "",  // 模型创建者
      modelCreatorAvatar: "",  // 模型创建者头像
      modelType: "1",
      modelColor: "",  // 模型颜色
      modelMetal: "",  // 模型光泽度
      modelNormal: "",  // 模型法线
      modelChartlet: "",  // 模型AO
      modelFile: "",  // 模型文件
      isCollection: 'no',
      showText: "模型加载中",
      // 0-5的随机数
      percentage: Math.floor(Math.random() * 8),
      productMsg: {},
      small: [],
      big: "",
      product: {
        salePrice: 0,
      },
      productNum: 1,
      userId: "",
      isLoading: true,
      industrialModel: [],
      industrialModels: [],
      depthMaterial: null,
      modelInformation: [
        {
          name: "模型大小",
          value: "",
        },
        {
          name: "模型格式",
          value: "",
        },
        {
          name: "模型尺寸",
          value: "",
        },
      ],
      company: "",
      description: "",
      lightDirection: new THREE.Vector3(0, 1, 0),
    };
  },
  components: {
    ModelShowFrame,
  },
  methods: {
    // 模型信息
    initInformation(){
      let id = this.$route.query.id 
      let key = this.$route.query.key
      let token = window.localStorage.getItem('userToken')
      if(this.$route.query.key){
         sharePrivateModel(key, token).then(res => {
          if(res.code === 200) {
            let data = res.data
            this.updateInformation(data)
            this.searchHandle(res.data.moreModels)
          }
          else{
            this.$message.error(res.message)
          }
        })
        return
      }
      getModelById(id, token).then(res => {
        if(res.code === 200) {
          let data = res.data
          this.updateInformation(data)
          this.searchHandle(res.data.moreModels)
        }else if(res.code === 404){
          this.$message.error('模型不存在')
          this.$router.push('/404')
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 更新全部模型信息
    updateInformation(data){
      this.id = data.id
      this.modelNote = data.remark ? data.remark : '暂无描述'
      this.modelName = data.name
      this.modelThumbnail = data.thumbnail
      this.modelTag = data.tags
      this.modelInformation[0].value = data.displaySize
      this.modelInformation[1].value = data.modelFormat
      this.modelInformation[2].value = data.modelLong.toFixed(2)  + " * " + data.modelWide.toFixed(2)  + " * " + data.modelHeight.toFixed(2)  + " m³"
      this.company = data.unit
      this.description = data.unitIntro
      this.modelCreateTime = data.updatedAt
      this.modelCreator = data.nickname
      this.modelCreatorAvatar = data.avatar
      this.modelColor = data.colorMap
      this.modelChartlet = data.thumbnail
      this.modelFile = data.modelUrl
      this.modelMetal = data.metallicMap
      this.modelNormal = data.normalMap
      this.isCollection = data.isCollected
    },
    // 推荐模型
    searchHandle(models){
      console.log(models);
      this.industrialModel = models
    },
    // 收藏模型
    addMyCollection(id){
      let token= window.localStorage.getItem('userToken')
      let obj = {isFavorite: true}
      if(this.$route.query.key){
         obj.shareKey = this.$route.query.key
      }
      changeCollectState(id, obj, token).then(res=>{
          if(res.code === 200){
              this.$message({
                  message: '收藏成功',
                  type: 'success'
              })
              this.isCollection = true
          }else if(res.code === 300){
            this.$message('请先登录')
            let info = { isOpen : true}
            setTimeout(() => {
                this.$bus.$emit('openDialog', info)
            }, 1000);
          }
          else{
              this.$message.error(res.message)
          }
      })
    },
    // 取消收藏
    cancelCollection(id){
        let token= window.localStorage.getItem('userToken')
        let obj = {isFavorite: false}
        if(this.$route.query.key){
           obj.shareKey = this.$route.query.key
        }
        changeCollectState(id,obj, token).then(res=>{
            if(res.code === 200){
                this.$message({
                    message: '已取消收藏',
                    type: 'success'
                })
                this.isCollection = false
            }else if(res.code === 300){
              this.$message('请先登录')
              let info = { isOpen : true}
              setTimeout(() => {
                  this.$bus.$emit('openDialog', info)
              }, 1000);
            }
            else{
                this.$message.error(res.message)
            }
        })
    },
    // 分享
    shareUrl(){
      let url = 'http://pongo.net.cn' + this.$route.fullPath
      // let url = 'http://localhost:8080' + this.$route.fullPath
      // navigator.clipboard.writeText(url).then(() => {
      //   this.$message.success('已复制到剪切板')
      // });
      if (navigator.clipboard && window.isSecureContext) {
          // navigator clipboard 向剪贴板写文本
          navigator.clipboard.writeText(url).then(() => {
            this.$message.success('已复制到剪切板')
          });
      } else {
          // 创建text area
          let textArea = document.createElement("textarea");
          textArea.value = url;
          // 使text area不在viewport，同时设置不可见
          textArea.style.position = "absolute";
          textArea.style.opacity = 0;
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          return new Promise((res, rej) => {
              // 执行复制命令并移除文本框
              document.execCommand('copy') ? res() : rej();
              textArea.remove();
              this.$message.success('已复制到剪切板')
          });
      }
    },
    makeXYZGUI( gui, vector3, name, onChangeFn ) {
      const folder = gui.addFolder( name );
      folder.add( vector3, 'x', - 10000, 10000, 100 ).onChange( onChangeFn );
      folder.add( vector3, 'y', -10000, 10000, 100 ).onChange( onChangeFn );
      folder.add( vector3, 'z', - 10000, 10000, 100 ).onChange( onChangeFn );
      folder.open();
    },
    makeXYZGUIC (gui, vector3, name, onChangeFn) {
        const folder = gui.addFolder(name);
        folder.add(vector3, 'x', -100, 100).onChange(onChangeFn);
        folder.add(vector3, 'y', -100, 100).onChange(onChangeFn);
        folder.add(vector3, 'z', -100, 100).onChange(onChangeFn);
        folder.open();
    },
    // 初始化三维场景
    init: function () {
      /**
       * 创建场景对象Scene
       */
      this.scene = new THREE.Scene();

      // 材质
      // let imgLoader = new DDSLoader();
      let imgLoader = new THREE.TextureLoader();
      imgLoader.format = THREE.RGBA_S3TC_DXT5_Format

      loadOnlineModel(this, this.scene, this.modelFile, this.modelColor, this.modelMetal, this.modelNormal, this.modelChartlet)
      /**
       * 光源设置
       */
      //直线光
      const light = new THREE.DirectionalLight(0xffffff, 5);
      const lightBack = new THREE.DirectionalLight(0xffffff, 3);
      lightBack.position.set(-6500, -10000, -10000);
      light.position.set(6660, 8000, 3000);
      light.target.position.set(0, 0, 0)
      light.castShadow = true;
      light.shadow.mapSize.width = 2048;
      light.shadow.mapSize.height = 2048;
      this.scene.add(light)
      this.scene.add(lightBack)
      this.scene.add(light.target)

      // 直线光辅助
      const helper1 = new THREE.DirectionalLightHelper(light, 5000);
      // this.scene.add(helper1)

      function updateLight() {
        light.target.updateMatrixWorld();
        helper1.update();
      }

      updateLight()

      // 设置投影
      this.depthMaterial = new THREE.MeshDepthMaterial();
      this.depthMaterial.userData.darkness = 5
      this.depthMaterial.depthTest = this.depthMaterial.depthWrite = false

      // const gui = new GUI();

      // gui.addColor( new ColorGUIHelper( lightBack, 'color' ), 'value' ).name( 'color' );
      // gui.add( lightBack, 'intensity', 0, 5, 0.01 );

      // this.makeXYZGUI( gui, lightBack.position, 'position', updateLight );
      // this.makeXYZGUI( gui, lightBack.target.position, 'target', updateLight );

      // 相机gui
      // 添加控制相机位置的 GUI
      // this.makeXYZGUIC(gui, this.camera.position, 'camera position', updateCameraPosition);

      // // 定义更新相机位置的方法
      // function updateCameraPosition() {
      //     camera.updateProjectionMatrix();
      // }
      

      //环境光
      const ambient = new THREE.AmbientLight(0xffffff, 1);
      this.scene.add(ambient);



      // 创建一个地面
      const groundGeometry = new THREE.PlaneGeometry(1000, 1000);
      const groundMaterial = new THREE.MeshStandardMaterial({ color: 0xffffff });
      const ground = new THREE.Mesh(groundGeometry, groundMaterial);
      ground.rotation.x = -Math.PI / 2; // 将地面置于水平位置
      ground.receiveShadow = true; // 地面接收阴影
      this.scene.add(ground);
      // const planeSize = 40;

      // 影子参数


      // const loader = new THREE.TextureLoader();
      // const texture = loader.load( 'https://threejs.org/manual/examples/resources/images/checker.png' );
      // texture.wrapS = THREE.RepeatWrapping;
      // texture.wrapT = THREE.RepeatWrapping;
      // texture.magFilter = THREE.NearestFilter;
      // texture.colorSpace = THREE.SRGBColorSpace;
      // const repeats = planeSize / 2;
      // texture.repeat.set( repeats, repeats );

      // const planeGeo = new THREE.PlaneGeometry( planeSize, planeSize );
      // const planeMat = new THREE.MeshPhongMaterial( {
      //   map: texture,
      //   side: THREE.DoubleSide,
      // } );
      // const mesh = new THREE.Mesh( planeGeo, planeMat );
      // mesh.receiveShadow = true;
      // mesh.rotation.x = Math.PI * - .5;
      // this.scene.add( mesh );
      // 网格地面
      const helper = new THREE.GridHelper(1000, 20)
      // this.scene.add(helper)

      // 增加天空盒
      // 创建rgbe加载器
      let background = new RGBELoader();
      background.load('./home/hdr4.hdr', (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        this.scene.environment = texture;
      });
      // 添加背景色纯色的
      this.scene.background = new THREE.Color(0xffffff)
      // 渐变的
      // this.scene.background = new THREE.Color(0xffffff);


      /**
       * 相机设置
       */
      const width = this.$refs.container.offsetWidth; //窗口宽度
      const height = this.$refs.container.offsetHeight; //窗口高度
      const k = width / height; //窗口宽高比
      const s = 100; //三维场景显示范围控制系数，系数越大，显示的范围越大
      //创建相机对象
      this.camera = new THREE.PerspectiveCamera(50, width / height, 0.1, 1000);
      this.camera.position.set(0, 4.6, 5); //设置相机位置
      this.camera.lookAt(this.scene.position); //设置相机方向(指向的场景对象)
      /**
       * 创建渲染器对象
       */
      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      this.renderer.setSize(width, height); //设置渲染区域尺寸
      this.renderer.physicallyCorrectLights = true; //物理正确的光照
      // this.renderer.setClearColor(0x000000, 1); //设置背景颜色
      this.renderer.shadowMap.enabled = true // 显示阴影
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap; // 阴影类型
      this.$refs.container.appendChild(this.renderer.domElement); //body元素中插入canvas对象
      //执行渲染操作   指定场景、相机作为参数
      this.controls = new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
      // this.controls.addEventListener('change', this.render);
      // renderer.render(scene, camera);

      // 辅助坐标系  参数250表示坐标系大小，可以根据场景大小去设置
      const axisHelper = new THREE.AxesHelper(1000);
      // this.scene.add(axisHelper);
    },
    render() {
      // this.scene.overrideMaterial = this.depthMaterial
      this.renderer.render(this.scene, this.camera); //执行渲染操作
      // this.mesh.rotateY(-0.01);//每次绕y轴旋转0.01弧度
      requestAnimationFrame(this.render); //请求再次执行渲染函数render
    }
  },
  mounted() {
    this.initInformation();
    this.searchHandle()
    // // 接收$bus
    // this.$bus.$on('reloadModel', (info) => {
      // this.id = info.id
      // this.initInformation()
      // window.location.reload()
    // })
    setTimeout(() => {
      this.init();
      this.render();
    }, 500);
  },
};
</script>
<style lang="less" scoped>
.lil-gui.autoPlace {
    right: 525px;
    top: 140px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
::v-deep .el-breadcrumb__inner.is-link{
  font-weight: 100;
  color: #666666;
}
::v-deep .el-breadcrumb__separator{
  color: #666666;
}
::v-deep .el-breadcrumb__inner{
  color: #666666 !important;
}
// .bg-purple-dark {
//   background: #99a9bf;
// }
// .bg-purple {
//   background: #d3dce6;
// }
// .bg-purple-light {
//   background: #e5e9f2;
// }
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 0px 0;
  background-color: #f9fafc;
}
.detail {
  // background-color: #d0d0d0;
  background:repeating-linear-gradient(to left,#1E1E1E,#151515);
  .detail_container{
    width: 80%;
    margin:0 auto;
    // background-color: #2b2b2b;
    padding-top: 1rem;
    padding-bottom: 50px;
  }
  // clear: both;
  // width: 90%;
  // min-width: 1220px;
  // background-color:#ffc5fb;
  // min-height: 600px;
  // padding: 0 0 25px;
  // margin: 0 auto;
}
.el-tag {
  height: 30px;
  margin: 0 10px 0 0;
}
.breadcrumb1 {
  display: flex;
  justify-content: space-between;
  .el-breadcrumb {
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  .translate{
    padding: 1rem 0 0 0;
    cursor: pointer;
  }
}
.breadcrumb {
  display: flex;
  padding: 3rem 0 0 0;
  border-top: 0.06rem solid #5C5C5C;
  .el-breadcrumb {
    font-size: 16px;
    // background-color: #d44d44;
  }
}

.information-box {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 0 0;
  // background-color: green;
  width: 100%;
  .information-wrapper {
    position: relative;
    width: 75%;
    .user{
      width: 100%;
      position: relative;
      .username{
        position: absolute;
        top: 7%;
        // transform: translateX(-50%);
        margin-left: 1rem;
        font-size: 1.5rem;
        font-weight: 100;
        color: #959595;
      }
      .time{
        position: absolute;
        color: #959595;
        font-size: 0.85rem;
        top:0;
        right: 0;
      }
    }
    .introduce{
      padding: 1.5rem 0 2rem 0;
      // background-color: #d44d44;
      color: #a6a6a6;
      p{
        font-size: 0.85rem;
        margin-bottom: 5px;
      }
      span{
        font-size: 0.73rem;
        letter-spacing: 1px;
      }
    }
    // width: 60rem;
    // height: 200px;
    // background: rgb(158, 255, 249);
    .model-name{
      font-size: 18px;
      font-weight: bold;
      line-height: 40px;
    }
  }
  .buy {
      width: 23%;
      // background-color: #8d8d8d;
      display: flex;
      justify-content: center;
    }
}

.gray-box {
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  // background-color: #282828;
  .gallery-wrapper {
    width: 75%;
    .gallery {
      display: flex;
      width: 100%;
      height: 100%;
        .big{
          width: 100%;
          ::v-deep .el-loading-spinner i{
            color: #54ceec;
          }
          ::v-deep .el-loading-spinner .el-loading-text{
            color: #54ceec;
          }
          .loadingModal{
            // position: relative;
            // top: 60%;
            // transform: translateY(-50%);
            z-index: 99;
            // ::v-deep .el-progress-bar__outer{
            //   background-color: #fff !important;
            //   height: 4px !important;
            // }
            // ::v-deep .el-progress-bar__inner{
            //   background-color: #54ceec;
            // }
            // ::v-deep .el-progress-bar__innerText{
            //   color: #54ceec;
            // }
          }
        .model_container {
          display: block;
          width: 100%;
          min-height: 75vh;
          // background-color: #d44d44;
        }
      }
    }
  }
  // 右边
  .banner {
    width: 25%;
    min-height: 75vh;
    margin-left: 1.5rem;
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2rem 1.5%;
    border-radius: 10px;
    h4 {
      font-size: 24px;
      line-height: 1.25;
      color: #000;
      margin-bottom: 13px;
    }
    h6 {
      font-size: 14px;
      line-height: 1.5;
      color: #bdbdbd;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .sku-custom-title {
      width: 100%;
      border-radius: 10px;
      // background-color: #9b9b9b;
      // padding: 0 2rem;
      margin-bottom: 1.5rem;
      img{
        width: 90%;
        aspect-ratio: 1/1;
        border-radius: 10px;
        display: block;
        margin: 0 auto;
      }
    }
    .num {
      width: 100%;
      padding: 1rem 1.5rem;
      border-top: 1px solid #999999;
      // background-color: #2066f2;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      .model_name{
        color: #DDDDDD;
        font-weight: 500;
        // letter-spacing: 1px;
        font-size: 1.1rem;
      }
      .label{
          font-size: 0.9rem;
          color: #c2c2c2;
          padding: 1rem 0 0 0;
          .tags{
            padding: 0 3px 0 3px;
            display: inline-block;

          }
      }
      ul{
        width: 100%;
        padding-top: 0.8rem;
      }
      ul li{
        padding: 0.5rem 0;
        border-bottom: 1px dashed #333333;
        display: flex;
        justify-content: space-between;
        font-size: 0.8rem;
        .name{
          // margin-right: 1rem;
          color: #666666;
        }
        .value{
          color: #DDDDDD;
        }
      }
      .company{
        color: #666666;
        // background-color: #d44d44;
        width: 100%;
        margin-top: 2rem;
        font-size: 0.8rem;
        p{
          color:#666666;
          line-height: 1.3rem;
        }
      }
      .collect{
        margin-top: 50px;
        ::v-deep .el-button{
            width: 155px;
            height: 40px;
            font-size: 1.2rem;
            border-radius: 30px;
            border: none;
            color: rgb(255, 255, 255);
            background-color: #707070;
        }
      }
    }
  }
}

.item-info {
  padding: 1rem 0;
  height: 400px;
  // background-color: red;
  // display: block;
  // display: flex;
  // justify-content: center
  // .img-item {
  //   width: 1220px;
  //   // padding: 1vw;
  //   text-align: center;
  //   img {
  //     width: 100%;
  //     height: auto;
  //     display: block;
  //   }
  // }
}

.no-info {
  padding: 200px 0;
  text-align: center;
  font-size: 30px;
}

.price {
  display: block;
  color: #d44d44;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  i {
    padding-left: 2px;
    font-size: 24px;
  }
}
</style>
